// extracted by css-extract-rspack-plugin
export default {"progress":"progress-c0m5Un","progressBar":"progressBar-sgtHoO"};